function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#xls_svg__clip0)",
  fill: "#0785FE"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.938 13.594V1.405c0-.259.21-.469.468-.469h7.032v1.875c0 .518.42.938.937.938h1.875v1.406h.938V3.281a.469.469 0 00-.136-.333L9.239.136A.469.469 0 008.906 0h-7.5C.63 0 0 .63 0 1.406v12.188C0 14.37.63 15 1.406 15h3.282v-.938H1.405a.469.469 0 01-.468-.468z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.145 7.758l-.52 1.036-.52-1.036a.469.469 0 00-.418-.258H3.75v.938h.647L5.1 9.844l-.703 1.406H3.75v.938h.938c.176-.001.337-.1.417-.258l.52-1.036.52 1.036c.08.157.241.257.418.258H7.5v-.938h-.647L6.15 9.844l.703-1.406H7.5V7.5h-.938c-.176 0-.337.1-.417.258zM13.594 9.375h-.938a.469.469 0 010-.938h.938c.259 0 .469.21.469.47H15c0-.777-.63-1.407-1.406-1.407h-.938a1.406 1.406 0 000 2.813h.938a.469.469 0 010 .937h-.938a.469.469 0 01-.469-.469h-.937c0 .777.63 1.406 1.406 1.406h.938a1.406 1.406 0 000-2.812zM8.906 7.5H7.97v4.219c0 .259.21.469.468.469h2.344v-.938H8.906V7.5z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "xls_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v15H0z"
})));

function SvgXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgXls;